import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { AppDispatch } from "store/store";
import PaymentCardDetail from "./PaymentCardDetail";
import InvoiceGrid from "./InvoiceGrid";
import { getInvoices } from "store/slices/InvoiceSlice";
import { useSubscriptionsLoader } from "shared/hooks/SubscriptionsLoader";
import Loader from "components/common/controls/Loader";

interface Props {
  dispatch: AppDispatch;
}

export function Invoices(props: Props) {
  const { dispatch } = props;
  const [isInvoiceDataLoaded, setIsInvoiceDataLoaded] = useState(false);
  // We will load subscription(if not loaded already) and invoice data.
  // Until loading completion we will display loader.
  // That's why it is set to true.
  const [isLoading, setIsLoading] = useState(true);

  // We will not load subscriptions if already loaded. That's why, forceLoad option is false.
  const [currentSubscription, isSubscriptionLoading] =
    useSubscriptionsLoader(false);

  useEffect(() => {
    if (currentSubscription?.id) {
      if (!currentSubscription.isOfflineSubscription) {
        dispatch(getInvoices(currentSubscription.id)).finally(() => {
          setIsInvoiceDataLoaded(true);
        });
      } else {
        // As there is no payment subscription available, assume invoice data is loaded.
        setIsInvoiceDataLoaded(true);
      }
    }
  }, [
    currentSubscription?.id,
    currentSubscription?.isOfflineSubscription,
    dispatch,
  ]);

  useEffect(() => {
    // Hide loader when subscription data and invoice data(list) is loaded.
    if (!isSubscriptionLoading && isInvoiceDataLoaded) {
      setIsLoading(false);
    }
  }, [isSubscriptionLoading, isInvoiceDataLoaded]);

  return (
    <div>
      {currentSubscription && currentSubscription.id && (
        <>
          <div className="mb-10">
            <PaymentCardDetail />
          </div>
          <div>
            <InvoiceGrid />
          </div>
        </>
      )}
      <Loader isVisible={isLoading} />
    </div>
  );
}

export default connect()(Invoices);
